import { createNode } from '@glueapp/graph-types';

export const E = createNode({
    id: 'E',
    name: 'E',
    description: "Euler's constant and the base of natural logarithms; approximately 2.718",
    aiDescription: 'Outputs Euler\'s number E (approximately 2.718). Has no input ports; the "E" output port provides the value.',
    category: 'Math',
    color: '#5daa5b',
    integration: undefined,
    inPorts: {},
    outPorts: {
        E: {
            kind: 'number',
        },
    },
    execute: function () {
        return { output: { E: Math.E } };
    },
});
